module.exports = __webpack_public_path__ + "img/service.146c9569.png";